import { Select } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const { Option } = Select;

export default function SelectTipoCliente({ value, onChange, disabled, onTipoClienteChange }) {
    const [tipiCliente, setTipoCliente] = useState([]);

    useEffect(() => {
        var items = [
            {
                "codice": "cliente_convenzionato",
                "nome": "Cliente Convenzionato"
            },
            {
                "codice": "ristoratore",
                "nome": "Ristoratore"
            }
        ];
        setTipoCliente(items);
        /*
        axios
            .get(`${process.env.REACT_APP_SERVER_URL}/api/aziende/all`)
            .then((response) => {
                setAziende(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
            */
    }, []);

    const handleChange = (val) => {
        const tipoClienteSelezionato = tipiCliente.find(a => a.codice === val);
        if (onTipoClienteChange) {
            onTipoClienteChange(tipoClienteSelezionato);
        }
        if (onChange) {
            onChange(val); // importante per AntD Form
        }
    };

    return (
        <Select
            showSearch
            style={{ width: 130 }}
            placeholder="Selezionare un tipo cliente"
            optionFilterProp="children"
            onChange={handleChange}
            onFocus={() => console.log('focus')}
            onBlur={() => console.log('blur')}
            onSearch={(val) => console.log('search:', val)}
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            value={value}
            disabled={disabled}
        >
            <Option value="">Nessuno</Option>
            {tipiCliente.map((tipo) => (
                <Option key={tipo.codice} value={tipo.codice}>
                    {tipo.nome}
                </Option>
            ))}
        </Select>
    );
}
